/* GTP video reviews: YouTube thumbnails loaded at runtime, click swaps in a nocookie embed. */
(function () {
  'use strict';
  if (customElements.get('gtp-video-reviews')) return;

  class GtpVideoReviews extends HTMLElement {
    connectedCallback() {
      var players = Array.prototype.slice.call(this.querySelectorAll('[data-gtp-vr-player]'));
      players.forEach(function (player) {
        var id = player.getAttribute('data-yt-id');
        if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
        var thumb = player.querySelector('[data-yt-thumb]');
        if (thumb && !thumb.getAttribute('src')) {
          thumb.setAttribute('src', 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg');
        }
        player.addEventListener('click', function () {
          if (player.querySelector('iframe')) return;
          var iframe = document.createElement('iframe');
          iframe.className = 'gtp-vr__iframe';
          var start = parseInt(player.getAttribute('data-start') || '0', 10);
          var src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
          if (start > 0) src += '&start=' + start;
          iframe.setAttribute('src', src);
          iframe.setAttribute('title', player.getAttribute('aria-label') || 'YouTube video');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
          player.innerHTML = '';
          player.appendChild(iframe);
          player.classList.add('is-playing');
        });
      });
    }
  }

  customElements.define('gtp-video-reviews', GtpVideoReviews);
})();
